var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21886,0,0,1.16177,3.35503,-9.71968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.641,41.467C76.641,26.377 60.138,14.126 39.812,14.126C19.485,14.126 2.982,26.377 2.982,41.467C2.982,50.291 8.718,58.572 18.386,63.705L14.031,87.785L33.843,68.447C35.816,68.687 37.812,68.808 39.812,68.808C60.138,68.808 76.641,56.557 76.641,41.467ZM74.18,41.467C74.18,46.818 71.784,51.74 67.822,55.752C61.509,62.144 51.296,66.226 39.812,66.226C37.907,66.226 36.006,66.111 34.127,65.882C33.411,65.795 32.694,66.041 32.167,66.556L17.848,80.533C17.848,80.532 20.804,64.187 20.804,64.187C21.008,63.056 20.475,61.921 19.497,61.401C10.778,56.771 5.444,49.426 5.444,41.467C5.444,36.116 7.839,31.194 11.801,27.182C18.114,20.791 28.327,16.708 39.812,16.708C51.296,16.708 61.509,20.791 67.822,27.182C71.784,31.194 74.18,36.116 74.18,41.467Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.758de07548a9bfc0ffd19bf7435bc34f.svg";
export { ForwardRef as ReactComponent };